import { useGetProperties } from "../../../base/hooks";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { ControlType, Property } from "../../../base/types";
import { TouUmsLinkProperties } from "./properties/TouUmsLinkProperties";
import { FC } from "react";

export const TOULinkComponent: FC<IControlAttributes> = ({
  control,
  className,
  children,
}) => {
  const { properties } = useGetProperties({ bindings: control.bindings });

  const redirectPath: string | undefined = properties[Property.TouRedirectPath];
  const target: string | undefined = properties[Property.Target];
  const title: string | undefined = properties[Property.Title];
  const hide: boolean | undefined = properties[Property.IsChecked];

  // prefix "/" for backend
  const finalRedirect = redirectPath
    ? redirectPath.startsWith("/") ? redirectPath : `${redirectPath}`
    : "/dashboard";

  const handleClick = () => {
    const akaUrl = `/toulink?type=tou&redirectTo=${encodeURIComponent(finalRedirect)}&target=${encodeURIComponent(target || "_self")}`;

    if (target === "_blank") {
      window.open(akaUrl, "_blank");
    } else {
      window.location.href = akaUrl;
    }
  };

  if (hide) return <></>;

  return (
    <div>
      <span
        className={className}
        style={{ cursor: "pointer" }}
        onClick={handleClick}
      >
        {title}
        {children}
      </span>
    </div>
  );
};

Registry.addControl({
  id: "7930854e-2f55-43e0-9587-7363af8a2d49",
  name: "TOULinkComponent",
  type: ControlType.TOULink,
  properties: TouUmsLinkProperties,
  component: TOULinkComponent,
});
